module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('aside', {
    staticClass: "control-sidebar control-sidebar-light",
    attrs: {
      "id": "recent-items-control-sidebar"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "control-sidebar-home-tab"
    }
  }, [_c('h3', {
    staticClass: "control-sidebar-heading"
  }, [_vm._v("Recent Activity")]), _vm._v(" "), _c('ul', {
    staticClass: "control-sidebar-menu"
  }, _vm._l((_vm.recentItems), function(item) {
    return _c('li', {
      attrs: {
        "id": "recentItemsLi"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.recentItemClick(item)
        }
      }
    }, [_c('i', {
      staticClass: "menu-icon fa fa-globe bg-red"
    }), _vm._v(" "), _c('div', {
      staticClass: "menu-info"
    }, [_c('h4', {
      staticClass: "control-sidebar-subheading"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.getVisitedDateString(item)) + " ")])])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "control-sidebar-bg"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs nav-justified control-sidebar-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#control-sidebar-home-tab",
      "data-toggle": "tab"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1b9be3fe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b9be3fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/recent-items-list/recent-items-list.vue.html
// module id = 1083
// module chunks = 0